import $ from "jquery";

export default {
  data: null,
  getLetterValue(letter) {
    let letterValues = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "X",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "R",
      "S",
      "T",
      "U",
      "W",
      "Y",
      "Z",
    ];
    for (let j = 0; j < letterValues.length; j++) {
      if (letter === letterValues[j]) {
        return j;
      }
    }
    return -1;
  },
  validateDO(numer) {
    if (numer == null || numer.length != 9) {
      return false;
    }

    numer = numer.toUpperCase();
    let letterValues = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    function getLetterValue(letter) {
      for (let j = 0; j < letterValues.length; j++)
        if (letter == letterValues[j]) return j;
      return -1;
    }

    //Check seria
    for (let i = 0; i < 3; i++) if (getLetterValue(numer[i]) < 10) return false;
    //Check number
    for (let i = 3; i < 9; i++)
      if (getLetterValue(numer[i]) < 0 || getLetterValue(numer[i]) > 9)
        return false;

    //sprawdz cyfre controlna
    let sum;
    sum =
      7 * getLetterValue(numer[0]) +
      3 * getLetterValue(numer[1]) +
      1 * getLetterValue(numer[2]) +
      7 * getLetterValue(numer[4]) +
      3 * getLetterValue(numer[5]) +
      1 * getLetterValue(numer[6]) +
      7 * getLetterValue(numer[7]) +
      3 * getLetterValue(numer[8]);
    sum %= 10;
    if (sum != getLetterValue(numer[3])) return false;

    return true;
  },
  validateRegon(regon) {
    if (typeof regon === "number") {
      regon = regon.toString();
    } else {
      regon = regon.replace(/-/g, "");
    }

    if (regon.length !== 9) {
      return false;
    }

    const regonArray = regon.split("").map((value) => parseInt(value));
    let checkSum =
      (8 * regonArray[0] +
        9 * regonArray[1] +
        2 * regonArray[2] +
        3 * regonArray[3] +
        4 * regonArray[4] +
        5 * regonArray[5] +
        6 * regonArray[6] +
        7 * regonArray[7]) %
      11;
    if (checkSum == 10) {
      checkSum = 0;
    }
    return regonArray[8] == checkSum;
  },
  validKw(kw) {
    return /^[a-zA-Z]{2}[0-9][a-zA-Z]\/[0-9]{1,8}\/[0-9]{1}$/.test(kw);
  },
  validIdNumber(num) {
    return (
      /^[a-zA-Z]{3}[ ]{1}[0-9]{6}$/.test(num) ||
      /^[a-zA-Z]{3}[0-9]{6}$/.test(num)
    );
  },
  validPassportNumber(num) {
    console.log("--" + num + "--");
    return (
      /^[a-zA-Z]{2}[0-9]{6}$/.test(num) || /^[a-zA-Z]{2}[0-9]{7}$/.test(num)
    );
  },
  validateKW(kw) {
    //Check length
    if (kw == null) {
      return false;
    }
    if (kw.length !== 15) {
      return false;
    }

    kw = kw.toUpperCase();

    //Check slashes
    if (kw[4] !== "/" || kw[13] !== "/") {
      return false;
    }

    //Check court id
    for (let i = 0; i < 2; i++) {
      if (this.getLetterValue(kw[i]) < 10) {
        return false;
      }
    }

    if (this.getLetterValue(kw[2]) < 0 || this.getLetterValue(kw[2]) > 9) {
      return false;
    }

    if (this.getLetterValue(kw[3]) < 10) {
      return false;
    }

    //Check numbers
    for (let i = 5; i < 13; i++) {
      if (this.getLetterValue(kw[i]) < 0 || this.getLetterValue(kw[i]) > 9) {
        return false;
      }
    }
    //Check checkdigit
    let sum =
      1 * this.getLetterValue(kw[0]) +
      3 * this.getLetterValue(kw[1]) +
      7 * this.getLetterValue(kw[2]) +
      1 * this.getLetterValue(kw[3]) +
      3 * this.getLetterValue(kw[5]) +
      7 * this.getLetterValue(kw[6]) +
      1 * this.getLetterValue(kw[7]) +
      3 * this.getLetterValue(kw[8]) +
      7 * this.getLetterValue(kw[9]) +
      1 * this.getLetterValue(kw[10]) +
      3 * this.getLetterValue(kw[11]) +
      7 * this.getLetterValue(kw[12]);
    sum %= 10;

    if (parseInt(kw[14]) !== sum) {
      return false;
    }
    return true;
  },
  init() {
    /* eslint-disable */
    let self = this;

    $.extend($.validator.messages, {
      required: "To pole jest wymagane.",
      remote: "Proszę o wypełnienie tego pola.",
      email: "Proszę o podanie prawidłowego adresu email.",
      url: "Proszę o podanie prawidłowego URL.",
      dateCorrect: "Podana data jest niepoprawna",
      date: "Proszę o podanie prawidłowej daty.",
      dateISO: "Proszę o podanie prawidłowej daty.",
      number: "Proszę o podanie prawidłowej liczby.",
      digits: "Proszę o podanie samych cyfr.",
      creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
      equalTo: "Proszę o podanie tej samej wartości ponownie.",
      extension: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
      nipPL: "Proszę o podanie prawidłowego numeru NIP.",
      maxlength: $.validator.format(
        "Proszę o podanie nie więcej niż {0} znaków."
      ),
      minlength: $.validator.format(
        "Proszę o podanie przynajmniej {0} znaków."
      ),
      rangelength: $.validator.format(
        "Proszę o podanie wartości o długości od {0} do {1} znaków."
      ),
      range: $.validator.format(
        "Proszę o podanie wartości z przedziału od {0} do {1}."
      ),
      max: $.validator.format(
        "Proszę o podanie wartości mniejszej bądź równej {0}."
      ),
      min: $.validator.format(
        "Proszę o podanie wartości większej bądź równej {0}."
      ),
      pattern: $.validator.format("Pole zawiera niedozwolone znaki."),
      equalToIgnoreCase: "Podane adresy e-mail muszą być jednakowe",
    });
    $.validator.addMethod(
      "dateLaterThanToday",
      function (value) {
        if (!value || value.length === "") {
          return true;
        }
        try {
          let date = new Date(value);
          let now = Date.now();
          if (date > now) return true;
        } catch (e) {
          console.log(e);
        }
        return false;
      },
      "Data nie może być z przeszłości"
    );
    $.validator.addMethod(
      "greaterThanDate",
      function (value, element, params) {
        if (!/Invalid|NaN/.test(new Date(value))) {
          return new Date(value) > new Date($(params).val());
        }

        console.log(value);
        console.log(params);
        return (
          (isNaN(value) && isNaN($(params).val())) ||
          Number(value) > Number($(params).val())
        );
      },
      "Nieprawidłowa data"
    );
    $.validator.addMethod(
      "nip2",
      function (value, element) {
        var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
        var nip = value.replace(/[\ \-]/gi, "");
        console.log(nip.length);
        if (nip.length != 10 && nip.length != 0) {
          return false;
        } else if (nip.length != 0) {
          var n = 0;
          for (var i = 0; i < 9; i++) {
            n += nip[i] * verificator_nip[i];
          }
          n %= 11;
          if (n != nip[9]) {
            return false;
          }
        }
        return true;
      },
      "Podaj prawidłowy numer NIP"
    );
    $.validator.addMethod(
      "kw",
      function (value, element) {
        return self.validateKW(value);
        // return self.validKw(value)
      },
      "Nieprawidłowy numer KW"
    );
    $.validator.addMethod(
      "dowod_osobisty",
      function (value, element) {
        return self.validateDO(value);
      },
      "Nieprawidłowy numer dowodu osobistego"
    );
    $.validator.addMethod(
      "regon",
      function (value, element) {
        if (!value || value.length === 0) return true;
        else return self.validateRegon(value);
      },
      "Nieprawidłowy numer REGON"
    );
    /* eslint-enable */

    $.validator.addMethod(
      "nip",
      function (value, element) {
        return this.optional(element) || /^\d{10}$/.test(value);
      },
      "Podaj NIP w formacie xxxxxxxxxx"
    );

    $.validator.addMethod(
      "postal",
      function (value, element) {
        return this.optional(element) || /^\d{2}-\d{3}$/.test(value);
      },
      "Podaj kod w formacie xx-xxx"
    );

    $.validator.addMethod(
      "phone",
      function (value, element) {
        return this.optional(element) || /^\d{9}$/.test(value);
      },
      "Podaj numer w formacie xxxxxxxxx (9 cyfr)"
    );

    $.validator.addMethod(
      "dateCorrect",
      function (value) {
        if (!value || value.length === "") {
          return true;
        }

        let regexYYYYMMDD =
          /^(?:19|20)\d\d-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2\d|3[01]))$/;
        let regexDDMMYYYY =
          /^(?:(?:0[1-9]|1\d|2\d|3[01])-(?:0[1-9]|1[0-2])-(?:19|20)\d\d)$/;

        if (value.charAt(2) === "-") return regexDDMMYYYY.test(value);
        else return regexYYYYMMDD.test(value);
      },
      "Podana data jest błędna"
    );
    $.validator.addMethod(
      "dateDmy",
      function (value) {
        if (!value || value.length === 0) {
          return true;
        }
        let regexDDMMYYYY =
          /^(?:(?:0[1-9]|1\d|2\d|3[01])-(?:0[1-9]|1[0-2])-(?:19|20)\d\d)$/;
        return regexDDMMYYYY.test(value);
      },
      "Podaj datę w formacie DD-MM-YYYY"
    );

    $.validator.addMethod(
      "datecheck",
      function (value) {
        return (
          value.toString().indexOf("_") === -1 &&
          value.toString().indexOf(" ") === -1
        );
      },
      "Podana data jest nieprawidłowa"
    );

    $.validator.addMethod(
      "dig",
      function (value) {
        if (value.length === 0) {
          return true;
        }
        let regex = /^[0-9]+$/;
        return regex.test(value);
      },
      "Wprowadź tylko cyfry"
    );

    $.validator.addMethod(
      "num",
      function (value) {
        if (value.length === 0) {
          return true;
        }
        let regex = /^[0-9.,]+$/;
        return regex.test(value);
      },
      "Podaj liczbę"
    );

    $.validator.addMethod(
      "account",
      function (value, element) {
        return (
          this.optional(element) ||
          /^\d{2} \d{4} \d{4} \d{4} \d{4} \d{4} \d{4}$/.test(value)
        );
      },
      "Podaj numer w formacie xx xxxx xxxx xxxx xxxx xxxx xxxx"
    );

    $.validator.addMethod(
      "num2",
      function (value) {
        if (value.length === 0) {
          return true;
        }
        let regex = /^[-+]?[0-9.,]+$/;
        return regex.test(value);
      },
      "Podaj liczbę"
    );

    $.validator.addClassRules("greaterThanDate", {
      greaterThanDate: true,
    });
    $.validator.addClassRules("dateLaterThanToday", {
      dateLaterThanToday: true,
    });
    $.validator.addMethod(
      "pesel",
      function (pesel) {
        if (!pesel || pesel.length === 0) return true;
        const allEqual = (arr) => arr.every((v) => v === arr[0]);

        let digits = `${pesel}`.split("");

        const reg = /^[0-9]{11}$/;
        if (reg.test(pesel) == false || allEqual(digits)) return false;

        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
        let sum = 0;

        for (let i = 0; i < weight.length; i++) {
          sum += weight[i] * pesel[i];
        }

        let int = 10 - (sum % 10);
        let intControlNr = int == 10 ? 0 : int;

        if (intControlNr == pesel[10]) {
          return true;
        }

        return false;
      },
      "Podaj prawidłowy PESEL"
    );

    $.validator.addMethod(
      "files",
      function (value, element) {
        if (
          $(element).closest("form").find('input[name="attachments[]"]')
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      },
      "Pamiętaj o załączeniu plików :)"
    );

    $.validator.addMethod(
      "dateAfterNow",
      function (value) {
        console.log(value);
        if (!value || value.length === "") {
          console.log("if true 1");
          return true;
        }
        console.log(value);
        try {
          // Check if the date is in DD-MM-YYYY format
          let formattedDate = value;
          if (value.charAt(2) === "-") {
            let parts = value.split("-");
            formattedDate = `${parts[0]}-${parts[1]}-${parts[2]}`;
          }
          console.log("formattedDate: " + formattedDate);

          // Assuming formattedDate is in "DD-MM-YYYY"
          let parts = formattedDate.split("-");
          // Note: Months are 0-indexed in JavaScript Date, so subtract 1 from the month
          let date = new Date(parts[2], parts[1] - 1, parts[0]);
          let now = new Date();
          now.setHours(0, 0, 0, 0);
          console.log(date.getTime() + " vs " + now.getTime());

          if (date.getTime() > now.getTime()) {
            console.log("if true 2");
            return true;
          }
        } catch (e) {
          console.log(e);
        }
        return false;
      },
      "Data nie może być z przeszłości"
    );

    $.validator.addMethod(
      "dateAfterYesterday",
      function (value) {
        if (!value || value.length === "") {
          return true;
        }
        try {
          // Check if the date is in DD-MM-YYYY format
          let formattedDate = value;
          if (value.charAt(2) === "-") {
            let parts = value.split("-");
            formattedDate = `${parts[0]}-${parts[1]}-${parts[2]}`;
          }

          let date = new Date(formattedDate);
          let yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          yesterday.setHours(0, 0, 0, 0);

          if (date.getTime() > yesterday.getTime()) return true;
        } catch (e) {
          console.log(e);
        }
        return false;
      },
      "Data nie może być z przeszłości"
    );
    $.validator.addMethod(
      "dateBeforeNow",
      function (value) {
        if (!value || value.length === "") {
          return true;
        }
        try {
          // Check if the date is in DD-MM-YYYY format
          let formattedDate = value;
          if (value.charAt(2) === "-") {
            let parts = value.split("-");
            formattedDate = `${parts[0]}-${parts[1]}-${parts[2]}`;
          }
          // Assuming formattedDate is in "DD-MM-YYYY"
          let parts = formattedDate.split("-");
          // Note: Months are 0-indexed in JavaScript Date, so subtract 1 from the month
          let date = new Date(parts[2], parts[1] - 1, parts[0]);
          let now = new Date();
          now.setHours(0, 0, 0, 0);

          if (date.getTime() <= now.getTime()) return true;
        } catch (e) {
          console.log(e);
        }
        return false;
      },
      "Data nie może być z przyszłości"
    );
    // $.validator.addMethod("dateFormat", function(value) {
    //   let dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/
    //
    //   if (value.match(dateReg)) {
    //     return true
    //   }
    //   return false;
    // }, 'Data nieprawidłowa');

    $.validator.addMethod(
      "equalToIgnoreCase",
      function (value, element, param) {
        return (
          this.optional(element) ||
          value.toLowerCase() === $(param).val().toLowerCase()
        );
      }
    );
    $.validator.addMethod(
      "lessThanField",
      function (value, element, param) {
        return (
          this.optional(element) || parseInt(value) > parseInt($(param).val())
        );
      },
      "Nieprawidłowa wartość"
    );

    $.validator.addClassRules("nip", {
      nip: true,
      nip2: true,
    });
    $.validator.addClassRules("kw", {
      kw: true,
    });

    $.validator.addClassRules("postal", {
      postal: true,
    });
    $.validator.addClassRules("files-required", {
      files: true,
    });
    $.validator.addClassRules("dateAfterNow", {
      dateAfterNow: true,
    });
    $.validator.addClassRules("dateAfterYesterday", {
      dateAfterYesterday: true,
    });
    $.validator.addClassRules("dateBeforeNow", {
      dateBeforeNow: true,
    });
    $.validator.addClassRules("dig", {
      dig: true,
    });
    $.validator.addClassRules("phone", {
      phone: true,
    });

    $.validator.addClassRules("num", {
      num: true,
    });

    $.validator.addMethod(
      "idNumber",
      function (value) {
        if (value.length === 0) {
          return true;
        }
        return self.validIdNumber(value);
      },
      "Prawidłowy format to AAA 123456"
    );
    $.validator.addMethod(
      "passportNumber",
      function (value) {
        if (value.length === 0) {
          return true;
        }
        return self.validPassportNumber(value);
      },
      "Prawidłowy format to AA1234567 lub AA123456"
    );

    $.validator.addClassRules("idNumber", {
      idNumber: true,
    });
    $.validator.addClassRules("passportNumber", {
      passportNumber: true,
    });
    $.validator.addClassRules("num2", {
      num2: true,
    });
    $.validator.addClassRules("pesel", {
      pesel: true,
    });

    $.validator.addClassRules("dateISO", {
      dateISO: true,
    });
    $.validator.addClassRules("datepicker", {
      datecheck: true,
    });
    $.validator.addClassRules("bank_account", {
      account: true,
    });
    $.validator.addClassRules("dateCorrect", {
      dateCorrect: true,
    });
    $.validator.addClassRules("dateDmy", {
      dateDmy: true,
    });
  },
};
